var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKantataKOrangeBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800.1",
    style: {
      enableBackground: "new 0 0 800 800.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE7523;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M700.2,799.9h-600c-55.2,0-100-44.8-100-100v-600c0-55.2,44.8-100,100-100h600c55.2,0,100,44.8,100,100v600 C800.2,755.1,755.4,799.9,700.2,799.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "185.4,148.7 608.4,148.7 415.6,393.8 617.7,651.1 182.7,651.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKantataKOrangeBox);
export default __webpack_public_path__ + "static/media/Kantata-K-Orange-Box.7c65e6877c17d2b642ad447612dd9d28.svg";
export { ForwardRef as ReactComponent };